import React from 'react'
import { AddressViewModel } from './AddressViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button } from 'react-bootstrap';
import fechar from '../../Imagens/close-24.png';
import salvar from '../../Imagens/save-16.png';
import deletar from '../../Imagens/delete-16.png';

import "../../Estilo/Form.css";
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { InputModalSelectComponent } from '../../Components/InputModalSelectComponent';
import Select from 'react-select';
import { confirmAlert } from 'react-confirm-alert';

interface MyProps {
    navigation: any
    delegate: AddressViewControllerDelegate
    viewModel: AddressViewModel
    idPrimary: number
    idPerson?: number
    idPoint?: number
}

export interface AddressViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class AddressViewController extends React.Component<MyProps> {

    private formEvent: FormEvent
    state = {
        isLoading: false,
        json: {},
        typeAddress: [],
        zone: [],
        blockFace: [],
        main: [],
        neighborhood: [],
        district: [],
        zoning: [],
        // streetCode: [],
        showButtonDelete: false,
        prefix: '',
        logradouroType: new Array<any>(),
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.loadOptions()
        this.loadSelect()
        if (this.props.idPrimary > 0) {
            this.loadStruct()
        }

        if (this.props.idPoint) {
            this.loadStruct()
        }
    }


    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Endereços</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                        id="cgependereco"
                                        defaultValue={json['cgependereco'] ? json['cgependereco'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Logradouro</Form.Label>
                                    <Form.Control
                                        id="logradouro"
                                        defaultValue={json['logradouro'] ? json['logradouro'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Lado Logradouro</Form.Label>
                                    <Select
                                        id="ladologradouro"
                                        value={this.formEvent.onValueSelect('select', 'ladologradouro', this.state.blockFace)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "ladologradouro")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.blockFace}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className='isRequired'>Tipo Logradouro</Form.Label>
                                    <Select
                                        id="tipologradouro"
                                        value={this.formEvent.onValueSelect('select', 'tipologradouro', this.state.logradouroType)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "tipologradouro")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.logradouroType}
                                        isMulti={false}
                                    />
                                </Col>
                                {/* 

                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Código Logradouro</Form.Label>
                                    <Select
                                        id="sgepcodigologradouro"
                                        value={this.formEvent.onValueSelect('select', 'sgepcodigologradouro', this.state.streetCode)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "sgepcodigologradouro")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.streetCode}
                                        isMulti={false}
                                    />
                                </Col>

                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Código Logradouro Secundário</Form.Label>
                                    <Select
                                        id="sgeplogradourosecundario"
                                        value={this.formEvent.onValueSelect('select', 'sgeplogradourosecundario', this.state.streetCode)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "sgeplogradourosecundario")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.streetCode}
                                        isMulti={false}
                                    />
                                </Col> */}
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Bloco</Form.Label>
                                    <Form.Control
                                        id="bloco"
                                        defaultValue={json['bloco'] ? json['bloco'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                        placeholder={"Digite"}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Apartamento</Form.Label>
                                    <Form.Control
                                        id="apartamento"
                                        defaultValue={json['apartamento'] ? json['apartamento'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                        placeholder={"Digite"}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Número</Form.Label>
                                    <Form.Control
                                        id="numero"
                                        defaultValue={json['numero'] ? json['numero'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Complemento</Form.Label>
                                    <Form.Control
                                        id="complemento"
                                        defaultValue={json['complemento'] ? json['complemento'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Bairro</Form.Label>
                                    <Select
                                        id="sgepbairros"
                                        value={this.formEvent.onValueSelect('select', 'sgepbairros', this.state.neighborhood)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "sgepbairros")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.neighborhood}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <InputModalSelectComponent
                                        id="Sequencial"
                                        keyValue="nome"
                                        label="Cidade"
                                        required={true}
                                        placeholder="Procure"
                                        showAddButton={false}
                                        navigation={this.props.navigation}
                                        titleModal="Cidades"
                                        table="cidade"
                                        valueDefault={json['municipio']}
                                        getValue={(id: number, value: string) => this.setCity(id, value)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>CEP</Form.Label>
                                    <Form.Control
                                        id="cep"
                                        maxLength={9}
                                        defaultValue={json['cep'] ? json['cep'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("cep", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Tipo</Form.Label>
                                    <Select
                                        id="tipo"
                                        value={this.formEvent.onValueSelect('select', 'tipo', this.state.typeAddress)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "tipo")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.typeAddress}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Zona</Form.Label>
                                    <Select
                                        id="zona"
                                        value={this.formEvent.onValueSelect('select', 'zona', this.state.zone)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "zona")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.zone}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Distrito</Form.Label>
                                    <Select
                                        id="sgepdistrito"
                                        value={this.formEvent.onValueSelect('select', 'sgepdistrito', this.state.district)}
                                        onChange={this.onChangeDistrict}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.district}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Zoneamento</Form.Label>
                                    <Select
                                        id="sgepzoneamento"
                                        value={this.formEvent.onValueSelect('select', 'sgepzoneamento', this.state.zoning)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "sgepzoneamento")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.zoning}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Identificador</Form.Label>
                                    <Form.Control
                                        id="identificador"
                                        value={json['identificador'] ? json['identificador'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Referência</Form.Label>
                                    <Form.Control
                                        id="referencia"
                                        defaultValue={json['referencia'] ? json['referencia'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Principal</Form.Label>
                                    <Select
                                        id="principal"
                                        value={this.formEvent.onValueSelect('select', 'principal', this.state.main)}
                                        onChange={(e: any) => this.formEvent.onChange("select", e, "principal")}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.main}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col xs="12" className="bottom10">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control
                                        id="descricao"
                                        as="textarea"
                                        rows={3}
                                        defaultValue={json['descricao'] ? json['descricao'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                        placeholder="Digite uma descrição"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" style={{ marginTop: 20 }}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                            src={salvar} />
                                        Salvar
                                    </Button>
                                    {!this.state.showButtonDelete &&
                                        <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>}
                                    {this.state.showButtonDelete &&
                                        <Button onClick={(e: any) => this.delete()} className="buttonCancel buttonDelete" variant="danger">
                                            <Image className="imageSave"
                                                src={deletar} />
                                            Remover
                                        </Button>}
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div>
        )
    }

    private async save() {
        var json = this.state.json as any
        if (json["logradouro"] == undefined || json["ccidade"] == undefined || json["sgepbairros"] == undefined || json["principal"] == undefined || json["sgepdistrito"] == undefined) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        if (json["logradouro"].length == 0) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        if (!json['tipologradouro']) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        if (this.props.idPerson) {
            json['sgeppessoa'] = this.props.idPerson
        }

        if (this.props.idPoint) {
            json['sgeppontos'] = this.props.idPoint
        }

        if (this.state.prefix && json['identificador'] && !json['identificador'].startsWith(this.state.prefix + '-')) {
            json['identificador'] = `${this.state.prefix}-${json['identificador']}`;
        }

        this.props.viewModel.fetchSave(json).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                this.props.delegate.tapDimiss(this.props.navigation);
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }
    private loadOptions() {
        const typeAddress = [
            { value: "RE", label: "Residencial", check: false },
            { value: "CO", label: "Comercial", check: false },
            { value: "CR", label: "Correspondência", check: false }
        ]

        const zone = [
            { value: "R", label: "Rural", check: false },
            { value: "U", label: "Urbano", check: false }
        ]

        const main = [
            { value: "S", label: "Sim", check: false },
            { value: "N", label: "Não", check: false }
        ]

        const logradouroType = [
            { value: '01', label: 'Acampamento' },
            { value: '02', label: 'Acesso' },
            { value: '03', label: 'Açude' },
            { value: '04', label: 'Adro' },
            { value: '05', label: 'Aeroporto' },
            { value: '06', label: 'Afluente' },
            { value: '07', label: 'Aglomerado' },
            { value: '08', label: 'Agrovila' },
            { value: '09', label: 'Alagado' },
            { value: '10', label: 'Alameda' },
            { value: '11', label: 'Aldeia' },
            { value: '12', label: 'Aleia' },
            { value: '13', label: 'Alto' },
            { value: '14', label: 'Anel' },
            { value: '15', label: 'Antiga' },
            { value: '16', label: 'Antigo' },
            { value: '17', label: 'Área' },
            { value: '18', label: 'Areal' },
            { value: '19', label: 'Arraial' },
            { value: '20', label: 'Arroio' },
            { value: '21', label: 'Artéria' },
            { value: '22', label: 'Assentamento' },
            { value: '23', label: 'Atalho' },
            { value: '24', label: 'Aterro' },
            { value: '25', label: 'Autódromo' },
            { value: '26', label: 'Avenida' },
            { value: '27', label: 'Baia' },
            { value: '28', label: 'Bairro' },
            { value: '29', label: 'Baixa' },
            { value: '30', label: 'Baixada' },
            { value: '31', label: 'Baixadão' },
            { value: '32', label: 'Baixão' },
            { value: '33', label: 'Baixo' },
            { value: '34', label: 'Balão' },
            { value: '35', label: 'Balneário' },
            { value: '36', label: 'Barra' },
            { value: '37', label: 'Barragem' },
            { value: '38', label: 'Barranca' },
            { value: '39', label: 'Barranco' },
            { value: '40', label: 'Barreiro' },
            { value: '41', label: 'Barro' },
            { value: '42', label: 'Beco' },
            { value: '43', label: 'Beira' },
            { value: '44', label: 'Beirada' },
            { value: '45', label: 'Belvedere' },
            { value: '46', label: 'Bloco' },
            { value: '47', label: 'Bocaina' },
            { value: '48', label: 'Boqueirão' },
            { value: '49', label: 'Bosque' },
            { value: '50', label: 'Boulevard' },
            { value: '51', label: 'Brejo' },
            { value: '52', label: 'Buraco' },
            { value: '53', label: 'Cabeceira' },
            { value: '54', label: 'Cachoeira' },
            { value: '55', label: 'Cachoeirinha' },
            { value: '56', label: 'Cais' },
            { value: '57', label: 'Calçada' },
            { value: '58', label: 'Calçadão' },
            { value: '59', label: 'Caminho' },
            { value: '60', label: 'Campo' },
            { value: '61', label: 'Canal' },
            { value: '62', label: 'Canteiro' },
            { value: '63', label: 'Capão' },
            { value: '64', label: 'Capoeira' },
            { value: '65', label: 'Cartódromo' },
            { value: '66', label: 'Central' },
            { value: '67', label: 'Centro' },
            { value: '68', label: 'Cerca' },
            { value: '69', label: 'Cerrado' },
            { value: '70', label: 'Cerro' },
            { value: '71', label: 'Chácara' },
            { value: '72', label: 'Chapada' },
            { value: '73', label: 'Chapadão' },
            { value: '74', label: 'Charco' },
            { value: '75', label: 'Cidade' },
            { value: '76', label: 'Circular' },
            { value: '77', label: 'Cohab' },
            { value: '78', label: 'Colina' },
            { value: '79', label: 'Colônia' },
            { value: '80', label: 'Comunidade' },
            { value: '81', label: 'Condomínio' },
            { value: '82', label: 'Conjunto' },
            { value: '83', label: 'Continuação' },
            { value: '84', label: 'Contorno' },
            { value: '85', label: 'Corredor' },
            { value: '86', label: 'Córrego' },
            { value: '87', label: 'Costa' },
            { value: '88', label: 'Coxilha' },
            { value: '89', label: 'Cruzamento' },
            { value: '90', label: 'Descida' },
            { value: '91', label: 'Desvio' },
            { value: '92', label: 'Dique' },
            { value: '93', label: 'Distrito' },
            { value: '94', label: 'Divisa' },
            { value: '95', label: 'Divisão' },
            { value: '96', label: 'Divisor' },
            { value: '97', label: 'Edifício' },
            { value: '98', label: 'Eixo' },
            { value: '99', label: 'Elevado' },
            { value: '100', label: 'Encosta' },
            { value: '101', label: 'Engenho' },
            { value: '102', label: 'Enseada' },
            { value: '103', label: 'Entrada' },
            { value: '104', label: 'Entreposto' },
            { value: '105', label: 'Entroncamento' },
            { value: '106', label: 'Escada' },
            { value: '107', label: 'Escadão' },
            { value: '108', label: 'Escadaria' },
            { value: '109', label: 'Escadinha' },
            { value: '110', label: 'Espigão' },
            { value: '111', label: 'Esplanada' },
            { value: '112', label: 'Esquina' },
            { value: '113', label: 'Estação' },
            { value: '114', label: 'Estacionamento' },
            { value: '115', label: 'Estádio' },
            { value: '116', label: 'Estância' },
            { value: '117', label: 'Estrada' },
            { value: '118', label: 'Extensão' },
            { value: '119', label: 'Faixa' },
            { value: '120', label: 'Favela' },
            { value: '121', label: 'Fazenda' },
            { value: '122', label: 'Feira' },
            { value: '123', label: 'Ferrovia' },
            { value: '124', label: 'Final' },
            { value: '125', label: 'Floresta' },
            { value: '126', label: 'Folha' },
            { value: '127', label: 'Fonte' },
            { value: '128', label: 'Fortaleza' },
            { value: '129', label: 'Freguesia' },
            { value: '130', label: 'Fundos' },
            { value: '131', label: 'Furo' },
            { value: '132', label: 'Galeria' },
            { value: '133', label: 'Gameleira' },
            { value: '134', label: 'Garimpo' },
            { value: '135', label: 'Gleba' },
            { value: '136', label: 'Granja' },
            { value: '137', label: 'Grota' },
            { value: '138', label: 'Habitacional' },
            { value: '139', label: 'Haras' },
            { value: '140', label: 'Hipódromo' },
            { value: '141', label: 'Horto' },
            { value: '142', label: 'Igarapé' },
            { value: '143', label: 'Ilha' },
            { value: '144', label: 'Inaplicável' },
            { value: '145', label: 'Invasão' },
            { value: '146', label: 'Jardim' },
            { value: '147', label: 'Jardinete' },
            { value: '148', label: 'Ladeira' },
            { value: '149', label: 'Lado' },
            { value: '150', label: 'Lago' },
            { value: '151', label: 'Lagoa' },
            { value: '152', label: 'Lagoinha' },
            { value: '153', label: 'Largo' },
            { value: '154', label: 'Lateral' },
            { value: '155', label: 'Leito' },
            { value: '156', label: 'Ligação' },
            { value: '157', label: 'Limeira' },
            { value: '158', label: 'Limite' },
            { value: '159', label: 'Limites' },
            { value: '160', label: 'Linha' },
            { value: '161', label: 'Lote' },
            { value: '162', label: 'Loteamento' },
            { value: '163', label: 'Lugarejo' },
            { value: '164', label: 'Maloca' },
            { value: '165', label: 'Manancial' },
            { value: '166', label: 'Mangue' },
            { value: '167', label: 'Margem' },
            { value: '168', label: 'Margens' },
            { value: '169', label: 'Marginal' },
            { value: '170', label: 'Marina' },
            { value: '171', label: 'Mata' },
            { value: '172', label: 'Mato' },
            { value: '173', label: 'Módulo' },
            { value: '174', label: 'Monte' },
            { value: '175', label: 'Morro' },
            { value: '176', label: 'Muro' },
            { value: '177', label: 'Não Especificado' },
            { value: '178', label: 'Núcleo' },
            { value: '179', label: 'Oca' },
            { value: '180', label: 'Oleoduto' },
            { value: '181', label: 'Olho' },
            { value: '182', label: 'Olhos' },
            { value: '183', label: 'Orla' },
            { value: '184', label: 'Outros' },
            { value: '185', label: 'Paço' },
            { value: '186', label: 'Palafita' },
            { value: '187', label: 'Pântano' },
            { value: '188', label: 'Parada' },
            { value: '189', label: 'Paradouro' },
            { value: '190', label: 'Paralela' },
            { value: '191', label: 'Parque' },
            { value: '192', label: 'Particular' },
            { value: '193', label: 'Passagem' },
            { value: '194', label: 'Passarela' },
            { value: '195', label: 'Passeio' },
            { value: '196', label: 'Passo' },
            { value: '197', label: 'Pasto' },
            { value: '198', label: 'Pátio' },
            { value: '199', label: 'Pavilhão' },
            { value: '200', label: 'Pedra' },
            { value: '201', label: 'Pedras' },
            { value: '202', label: 'Pedreira' },
            { value: '203', label: 'Penhasco' },
            { value: '204', label: 'Perimetral' },
            { value: '205', label: 'Perímetro' },
            { value: '206', label: 'Perto' },
            { value: '207', label: 'Planalto' },
            { value: '208', label: 'Plataforma' },
            { value: '209', label: 'Ponta' },
            { value: '210', label: 'Ponte' },
            { value: '211', label: 'Ponto' },
            { value: '212', label: 'Porto' },
            { value: '213', label: 'Posto' },
            { value: '214', label: 'Povoado' },
            { value: '215', label: 'Praça' },
            { value: '216', label: 'Praia' },
            { value: '217', label: 'Projeção' },
            { value: '218', label: 'Projetada' },
            { value: '219', label: 'Projeto' },
            { value: '220', label: 'Prolongamento' },
            { value: '221', label: 'Propriedade' },
            { value: '222', label: 'Próximo' },
            { value: '223', label: 'Quadra' },
            { value: '224', label: 'Quarteirão' },
            { value: '225', label: 'Quilombo' },
            { value: '226', label: 'Quilômetro' },
            { value: '227', label: 'Quinta' },
            { value: '228', label: 'Quintas' },
            { value: '229', label: 'Rachão' },
            { value: '230', label: 'Ramal' },
            { value: '231', label: 'Rampa' },
            { value: '232', label: 'Rancho' },
            { value: '233', label: 'Recanto' },
            { value: '234', label: 'Região' },
            { value: '235', label: 'Represa' },
            { value: '236', label: 'Residencial' },
            { value: '237', label: 'Reta' },
            { value: '238', label: 'Retiro' },
            { value: '239', label: 'Retorno' },
            { value: '240', label: 'Riacho' },
            { value: '241', label: 'Ribanceira' },
            { value: '242', label: 'Ribeirão' },
            { value: '243', label: 'Rincão' },
            { value: '244', label: 'Rio' },
            { value: '245', label: 'Rocha' },
            { value: '246', label: 'Rochedo' },
            { value: '247', label: 'Rodovia' },
            { value: '248', label: 'Rotatória' },
            { value: '249', label: 'Rótula' },
            { value: '250', label: 'Rua' },
            { value: '251', label: 'Ruela' },
            { value: '252', label: 'Saco' },
            { value: '253', label: 'Saída' },
            { value: '254', label: 'Sanga' },
            { value: '255', label: 'Sede' },
            { value: '256', label: 'Sem' },
            { value: '257', label: 'Seringal' },
            { value: '258', label: 'Serra' },
            { value: '259', label: 'Sertão' },
            { value: '260', label: 'Servidão' },
            { value: '261', label: 'Seta' },
            { value: '262', label: 'Setor' },
            { value: '263', label: 'Sítio' },
            { value: '264', label: 'Sopé' },
            { value: '265', label: 'Subida' },
            { value: '266', label: 'Superquadra' },
            { value: '267', label: 'Tapera' },
            { value: '268', label: 'Terminal' },
            { value: '269', label: 'Terra' },
            { value: '270', label: 'Terreno' },
            { value: '271', label: 'Terrenos' },
            { value: '272', label: 'Transversal' },
            { value: '273', label: 'Travessa' },
            { value: '274', label: 'Travessão' },
            { value: '275', label: 'Travessia' },
            { value: '276', label: 'Trecho' },
            { value: '277', label: 'Trevo' },
            { value: '278', label: 'Trilha' },
            { value: '279', label: 'Trilho' },
            { value: '280', label: 'Trilhos' },
            { value: '281', label: 'Trincheira' },
            { value: '282', label: 'Túnel' },
            { value: '283', label: 'Unidade' },
            { value: '284', label: 'Usina' },
            { value: '285', label: 'Vala' },
            { value: '286', label: 'Valão' },
            { value: '287', label: 'Vale' },
            { value: '288', label: 'Vargem' },
            { value: '289', label: 'Variante' },
            { value: '290', label: 'Várzea' },
            { value: '291', label: 'Velódromo' },
            { value: '292', label: 'Vereda' },
            { value: '293', label: 'Vertente' },
            { value: '294', label: 'Via' },
            { value: '295', label: 'Viaduto' },
            { value: '296', label: 'Vicinal' },
            { value: '297', label: 'Viela' },
            { value: '298', label: 'Vila' },
            { value: '299', label: 'Vilarejo' },
            { value: '300', label: 'Volta' },
            { value: '301', label: 'Zona' },
            { value: '302', label: '1ª Travessa da Avenida' },
            { value: '303', label: '1ª Travessa da Rua' },
            { value: '304', label: '2ª Travessa da Avenida' },
            { value: '305', label: '2ª Travessa da Rua' },
            { value: '306', label: '3ª Travessa da Avenida' },
            { value: '307', label: '3ª Travessa da Rua' },
            { value: '308', label: '4ª Travessa da Avenida' },
            { value: '309', label: '4ª Travessa da Rua' },
            { value: '310', label: '5ª Travessa da Avenida' },
            { value: '311', label: '5ª Travessa da Rua' }
        ]

        this.setState({
            typeAddress,
            zone,
            main,
            logradouroType
        })
    }



    private loadSelect() {
        this.props.viewModel.fetchSelectProperty().then((rs) => {
            var json = rs.length > 0 ? rs[0] : {} as any
            var keys = Object.keys(json)

            for (var i = 0; i < keys.length; i++) {
                var array = Array<any>()
                var result = json[keys[i]] as Array<any>

                for (var a = 0; a < result.length; a++) {
                    var item = result[a]
                    array.push({ value: item.id, label: item.value, check: false })
                }

                switch (keys[i]) {
                    case "gepbairros":
                        this.setState({ neighborhood: array })
                        break;
                    case "gepdistrito":
                        this.setState({ district: array })
                        break;
                    case "gepzoneamento":
                        this.setState({ zoning: array })
                        break;
                    case "gepladologradouro":
                        this.setState({ blockFace: array })
                        break
                    // case "gepcodigologradouro":
                    //     this.setState({ streetCode: array })
                    //     break;
                }
            }
        })
    }

    private setCity(id: number, value: string) {
        var json = this.state.json as any
        json['ccidade'] = id
        json['municipio'] = value

        this.setState({
            json: json
        })
    }

    private loadStruct() {
        var json = this.state.json as any
        json['cgependereco'] = this.props.idPrimary

        if (this.props.idPerson) {
            json['sgeppessoa'] = this.props.idPerson
        }

        if (this.props.idPoint) {
            json['sgeppontos'] = this.props.idPoint
        }


        this.setState({ isLoading: true })
        this.props.viewModel.fetchDataOne(json).then((rs) => {
            var resultado = rs as Array<any>
            if (resultado.length > 0) {
                this.setState({
                    isLoading: false,
                    json: resultado[0],
                    showButtonDelete: this.props.idPoint ? true : false,
                    prefix: resultado[0].prefixo
                })

                return
            }

            this.setState({ isLoading: false })
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    private delete() {
        confirmAlert({
            title: 'Atenção!',
            message: 'Deseja excluir esse registro?',
            buttons: [{
                label: 'Sim',
                onClick: () => {
                    this.setState({ showLoading: true })
                    this.props.viewModel.fetchDelete(this.state.json).then(() => {
                        this.setState({ showLoading: false })
                        toast.success("Registro deletado com sucesso!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });

                        setTimeout(() => {
                            this.props.delegate.tapDimiss(this.props.navigation);
                        }, 1000);
                    }, e => {
                        this.setState({ showLoading: false })
                        toast.error(JSON.stringify(e), {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    })
                }
            },
            {
                label: 'Não',
                onClick: () => {

                }
            }]
        })
    }


    private onChangeDistrict = async (e: any) => {
        this.formEvent.onChange("select", e, "sgepdistrito");
        const json = this.state.json as any
        const response = await this.props.viewModel.loadAcronymByDistrict(e.value)
        if (json['identificador']) {
            if (response.identificador) {
                json['identificador'] = response.identificador
            } else {
                json['identificador'] = ''
            }
        } else {
            json['identificador'] = response.identificador
        }
        this.setState({
            prefix: response.sigla,
            json
        });
    };



}

